import React from 'react';

const LocationDetail = ({ data, setIsLocationDetailModalOpen }) => {
    const hasDetails = Object.keys(data?.locationDetail || {}).length > 0;

    return (
        <div className="mt-4 flex flex-col gap-3 rounded-xl bg-[#f7f2ef] p-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
                <span className={`flex h-9 w-9 items-center justify-center rounded-lg ${hasDetails ? 'bg-emerald-100 text-emerald-700' : 'bg-orange-100 text-[#fb6635]'}`}>
                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 21s7-4.35 7-11a7 7 0 1 0-14 0c0 6.65 7 11 7 11Zm0-8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                    </svg>
                </span>
                <p className="text-sm font-semibold text-[#211b4f]">
                    Location Details
                    <span className="text-red-600"> *</span>
                </p>
            </div>
            <button
                onClick={() => setIsLocationDetailModalOpen(true)}
                className="inline-flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-[#211b4f] text-white transition-colors hover:bg-[#30266c]"
                type="button"
                aria-label={hasDetails ? 'Edit location details' : 'Add location details'}
            >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={hasDetails ? '2' : '3'} d={hasDetails ? 'M16.862 3.487a2.1 2.1 0 0 1 2.97 2.97L8.5 17.79 4 19l1.21-4.5L16.862 3.487Z' : 'M5 12h14m-7 7V5'} />
                </svg>
            </button>
        </div>
    );
};

export default LocationDetail;
